import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail, Clock } from "lucide-react";
import { BRAND } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white">
      {/* Top callout */}
      <div className="bg-[#f5a623] py-10">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h3 className="display-font text-3xl md:text-4xl font-bold text-[#0a0a0a] mb-2">
            Ready to Build Something Tough?
          </h3>
          <p className="text-[#0a0a0a]/80 mb-5">
            Call us, drop in, or send a message — we’ll get back same day.
          </p>
          <a
            href={BRAND.phoneHref}
            className="inline-flex items-center gap-2 bg-[#0a0a0a] text-white px-7 py-3.5 font-bold tracking-wide hover:bg-[#1a1a1a] transition-colors"
          >
            <Phone className="w-4 h-4" /> {BRAND.phone}
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="logo-block inline-block mb-5">
            <div className="flex items-center gap-2">
              <div className="flex flex-col leading-none">
                <span className="text-[26px] font-bold text-[#0a0a0a]">EMC</span>
                <span className="text-[8px] font-semibold text-[#0a0a0a] tracking-[0.25em]">INDUSTRIAL CORP.</span>
              </div>
              <div className="flex flex-col items-center justify-center bg-[#f5a623] border border-[#0a0a0a] px-1.5 py-0.5">
                <span className="text-[10px] font-bold text-[#c8102e] leading-none">TATU</span>
                <span className="text-[5px] font-bold text-[#0a0a0a] leading-none mt-0.5">DEALER</span>
              </div>
            </div>
          </div>
          <p className="text-[#aaaaaa] max-w-md leading-relaxed">
            Family-owned custom fabrication and authorized TATU Marchesan dealer.
            Forty years of welds, harvests, and handshakes — built in Miami.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href={BRAND.socials.facebook} aria-label="Facebook" className="w-10 h-10 border border-[#2a2a2a] flex items-center justify-center hover:bg-[#f5a623] hover:border-[#f5a623] hover:text-[#0a0a0a] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href={BRAND.socials.instagram} aria-label="Instagram" className="w-10 h-10 border border-[#2a2a2a] flex items-center justify-center hover:bg-[#f5a623] hover:border-[#f5a623] hover:text-[#0a0a0a] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={BRAND.socials.linkedin} aria-label="LinkedIn" className="w-10 h-10 border border-[#2a2a2a] flex items-center justify-center hover:bg-[#f5a623] hover:border-[#f5a623] hover:text-[#0a0a0a] transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="display-font uppercase tracking-wider text-sm font-bold mb-5 text-[#f5a623]">Visit Us</h4>
          <ul className="space-y-3 text-sm text-[#bdbdbd]">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-1 shrink-0 text-[#f5a623]" /><span>{BRAND.address.line1}<br/>{BRAND.address.line2}<br/>{BRAND.address.country}</span></li>
            <li className="flex gap-3 items-center"><Phone className="w-4 h-4 text-[#f5a623]" /><a href={BRAND.phoneHref} className="hover:text-[#f5a623]">{BRAND.phone}</a></li>
            <li className="flex gap-3 items-center"><Mail className="w-4 h-4 text-[#f5a623]" /><a href={`mailto:${BRAND.email}`} className="hover:text-[#f5a623]">{BRAND.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="display-font uppercase tracking-wider text-sm font-bold mb-5 text-[#f5a623] flex items-center gap-2"><Clock className="w-4 h-4" /> Hours</h4>
          <ul className="space-y-1.5 text-sm text-[#bdbdbd]">
            {BRAND.hours.map((h) => (
              <li key={h.d} className="flex justify-between">
                <span className="font-semibold text-white">{h.d}</span>
                <span>{h.h}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1a1a1a] py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#888]">
          <p>© {new Date().getFullYear()} EMC Industrial — Engineered Manufacturing Corp. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/" className="hover:text-[#f5a623]">Home</Link>
            <Link to="/warranty" className="hover:text-[#f5a623]">Warranty</Link>
            <Link to="/about" className="hover:text-[#f5a623]">About</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
